module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_MaizChipotle.3e5d0e06.pdf";